export default "__VITE_ASSET__DKUCXVG4__"